import React, { useEffect } from "react";
import { GeneralModal } from "../GeneralComponents/GeneralModal";
import { useModalAlert } from "../GeneralComponents";

export function DocumentaryTRD({ row, openModal, handleCloseModal }) {
  const [formData, setFormData] = React.useState({
    id_gd_dependencia: "",
    id_gd_subseries: "",
    id_gd_tipo_documental: [],
  });

  const [isView, setIsView] = React.useState(false);
  const [listsubseries, setListSubseries] = React.useState([]);
  const [listSeries, setListSeries] = React.useState([]);
  const [listTypesDocumentales, setListTypesDocumentales] = React.useState([]);
  const { showModalAlert } = useModalAlert();

  useEffect(() => {
    loadSeries();
    loadSubseries();
    loadTipoDocumentales();
  }, []);

  const newModalField = [
    {
      name: "id_gd_series",
      label: "Serie",
      type: "select",
      options: listSeries,
    },
    {
      name: "id_gd_subseries",
      label: "Subserie",
      type: "select",
      options: listsubseries,
    },
    {
      name: "id_gd_tipo_documental",
      label: "Tipos Documentales TRD",
      type: "autocomplete-checkbox",
      options: listTypesDocumentales,
    },
  ];
  const requiredFields = [
    "id_gd_series",
    "id_gd_subseries",
    "id_gd_tipo_documental",
  ];

  const consultarRegistro = async () => {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "dependencia-trd/consult",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    );
  };

  const loadSeries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "series/listar?estado=A", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("lista de series..", data.results);

        const listaserie = data.results.map((serie) => {
          return { value: serie.id_gd_series, label: serie.descripcion };
        });
        setListSeries(listaserie);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadSubseries = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "subseries/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listasubserie = data.results.map((subserie) => {
          return {
            value: subserie.id_gd_subseries,
            label: subserie.descripcion,
          };
        });
        setListSubseries(listasubserie);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoDocumentales = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documental/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listatipoDocumental = data.results.map((tipoDocumental) => {
          return {
            value: tipoDocumental.id_gd_tipo_documental,
            label: tipoDocumental.descripcion,
          };
        });
        setListTypesDocumentales(listatipoDocumental);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async (formData) => {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));
    let datos = {
      ...formData,
      id_gd_dependencia: row.id_gd_dependencia,
      id_usuario: usuario.id_usuario,
    };
    console.log("datos..", datos);

    try {
      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "dependencia-trd/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(datos),
        },
      );
      const result = await updateResponse.json();
      handleCloseModal();
      consultarRegistro();
      showModalAlert("success", "Se asocio correctamente la trd");
    } catch (error) {
      showModalAlert("danger", "Error al asociar la trd");
    }
  };

  return (
    <GeneralModal
      open={openModal}
      titleAlert={"TRD"}
      onClose={handleCloseModal}
      fields={newModalField}
      formData={formData}
      onFieldChange={handleFieldChange}
      onSave={handleSave}
      setFormData={setFormData}
      initialFormData={{
        id_gd_series: "",
        id_gd_subseries: "",
        id_gd_tipo_documental: [],
      }}
      enableDocumentarytype={true}
      isView={isView}
      setIsView={setIsView}
      title={"Asociar TRD"}
      requiredFields={requiredFields}
    />
  );
}
